module.exports = {
	reuseDialogMessage: gettext('You have previously completed this task. Would you like to reuse the data you provided?'),
	reuseFilesMessage: gettext('You have previously completed this task. Would you like to reuse the files you provided?'),
	reuseRecommendationsMessage: gettext('You have previously completed this task. Would you like to reuse the recommendations you received?'),
	overwriteDataCheckboxMessage: gettext('Overwrite any data I have already added to this task'),
	previousInstance: gettext('Previous instance'),
	previousInstances: gettext('Previous instances'),
};